if (!customElements.get('loop-campaign-video')) {
  customElements.define('loop-campaign-video', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.video = this.querySelector('video');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      if (!this.video) return;
      this.video.setAttribute('aria-hidden', 'true');
      this.video.muted = true;
      this.video.addEventListener('playing', () => { this.classList.add('is-playing'); }, options);
      this.video.addEventListener('error', () => { this.classList.remove('is-playing'); }, options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.video.pause();
        else this.autoPlay();
      }, options);
      this.connection?.addEventListener('change', () => this.autoPlay(), options);
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        if (!this.visible) this.video.pause();
        else this.autoPlay();
      }, { threshold: 0.1 });
      this.observer.observe(this);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else this.autoPlay();
      }, options);
    }
    autoPlay() {
      const constrainedNetwork =
        this.connection?.saveData ||
        this.connection?.effectiveType === 'slow-2g' ||
        this.connection?.effectiveType === '2g';

      if (constrainedNetwork) {
        this.video.pause();
        this.classList.remove('is-playing');
        return;
      }

      if (this.dataset.autoplay === 'true' && this.visible && !document.hidden && !this.motion.matches) {
        this.selectSource();
        if (this.video.getAttribute('src')) this.play();
      }
    }
    selectSource() {
      if (this.video.getAttribute('src')) return;
      const slowConnection = this.connection?.effectiveType === '3g' ||
        (typeof this.connection?.downlink === 'number' && this.connection.downlink < 5);
      const mobileScreen = matchMedia('(max-width: 749px)').matches;
      const source = mobileScreen || slowConnection
        ? this.dataset.videoLight || this.dataset.videoHigh
        : this.dataset.videoHigh || this.dataset.videoLight;
      if (source) {
        this.video.src = source;
        this.video.load();
      }
    }
    play() { this.video.play().catch(() => { this.classList.remove('is-playing'); }); }
    disconnectedCallback() { this.video?.pause(); this.observer?.disconnect(); this.controller?.abort(); }
  });
}
